import React, { forwardRef } from "react";
import { useDealerSetupForm, usePager } from "../DealerSetupUtils";
import { array, number, object, string } from "yup";
import VariationsInput from "../Fields/VariationsInput";
import IConquest from "../../../../interfaces/DealerSetup/IConquest";
import IFormValues from "../../../../interfaces/DealerSetup/IFormValues";

interface IProps {
    path: string;
    formValues: IFormValues;
    savePage(path: string, validatePage: () => void): void;
}

const Conquests = forwardRef(({ formValues, savePage, path }: IProps, ref: React.Ref<{}>) => {
    const defaults: IConquest = {
        fields: {
            conquest: {
                value: {
                    ad_groups: [
                        {
                            value: {
                                name: "",
                                variations: []
                            }
                        }
                    ],
                    negative_keyword_lists: []
                }
            }
        }
    };

    const schema = object({
        conquest: object({
            value: object({
                ad_groups: array().of(
                    object({
                        name: string().required("The Name field is required.").min(1),
                        variations: array().of(string())
                    })
                )
            })
        })
    });

    const [values, handleFieldChange, changePage] = useDealerSetupForm(
        defaults,
        formValues,
        schema,
        ref,
        path,
        savePage
    );

    const pager = usePager(path, formValues, changePage);

    const handleChange = (index: number, value: any) => {
        handleFieldChange(`conquest.value.ad_groups[${index}]`, value);
    };

    const handleAdd = () => {
        handleFieldChange(
            `conquest.value.ad_groups[${values.fields.conquest.value.ad_groups.length}]`,
            defaults.fields.conquest.value.ad_groups[0],
            true
        );
    };

    const handleDelete = (index: number) => {
        values.fields.conquest.value.ad_groups.splice(index, 1);
        handleFieldChange(`conquest`, values.fields.conquest, true);
    };

    return (
        <div className="p-4">
            <div className="text-xl font-bold">Conquest Setup</div>

            <div className="text-lg font-bold mt-4 pb-3 border-b">Dealer Conquests</div>

            {values.fields.conquest.value.ad_groups &&
                values.fields.conquest.value.ad_groups.map((field: any, index: number) => (
                    <VariationsInput
                        index={index}
                        key={index}
                        label={"Conquest"}
                        name="name"
                        value={field.value.name || defaults.fields.conquest.value.ad_groups[0].value.name}
                        variations={
                            field.value.variations || defaults.fields.conquest.value.ad_groups[0].value.variations
                        }
                        className={index > 0 ? "border-t border-gray-400 w-2/3 mt-4" : ""}
                        errors={field.errors}
                        deletable={values.fields.conquest.value.ad_groups.length > 1}
                        handleChange={handleChange}
                        handleDelete={handleDelete}
                    />
                ))}

            <button className="text-base font-bold text-blue-500 my-4 pb-3" onClick={handleAdd}>
                + Add Conquest
            </button>

            {pager()}
        </div>
    );
});

export default Conquests;
